import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=71d8fb24&scoped=true&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=71d8fb24&scoped=true&lang=css&"
import style1 from "./RoleList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8fb24",
  null
  
)

export default component.exports